import { render, staticRenderFns } from "./FolderIcon.vue?vue&type=template&id=54810355&scoped=true"
import script from "./FolderIcon.vue?vue&type=script&lang=js"
export * from "./FolderIcon.vue?vue&type=script&lang=js"
import style0 from "./FolderIcon.vue?vue&type=style&index=0&id=54810355&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54810355",
  null
  
)

export default component.exports